import {
  API_HOST,
  getHttpPostOptions,
  getHttpGetOptions,
  getHttpPutOptions,
  getHttpDeleteOptions
} from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/system-user`;
const getSpecificEndpoint = (externalReference) => `${getEndpoint()}/${externalReference}`;
const getResetPasswordEndpoint = () => `${getEndpoint()}/reset-password`;
const getDeleteAccountEndpoint = (systemUserExternalReference) =>
  `${getEndpoint()}/delete-account/${systemUserExternalReference}`;

export const getCreateSystemUserRequest = (systemUser) => [getEndpoint(), getHttpPostOptions(systemUser)];

export const getViewSystemUserRequest = (externalRefernce) => [
  getSpecificEndpoint(externalRefernce),
  getHttpGetOptions()
];

export const getUpdateSystemUserRequest = (systemUser) => [getEndpoint(), getHttpPutOptions(systemUser)];

export const getInitiatePasswordResetRequest = (email, mobileNumber) => [
  getResetPasswordEndpoint(),
  getHttpPostOptions({ email, mobileNumber })
];

export const getResetPasswordRequest = (systemUser) => [getResetPasswordEndpoint(), getHttpPutOptions(systemUser)];

export const getDeleteAccountRequest = (systemUserExternalReference) => [
  getDeleteAccountEndpoint(systemUserExternalReference),
  getHttpDeleteOptions()
];
